import { render, staticRenderFns } from "./TitleListSortingSwitcherSeo.vue?vue&type=template&id=cf681a96"
import script from "./TitleListSortingSwitcherSeo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleListSortingSwitcherSeo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleListSortingSwitcherSeo.vue?vue&type=style&index=0&id=cf681a96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports